<template>
  <div class="patient-form-container" :class="modalTheme">
    <!-- Add the load button at the top -->
    <!-- <div class="form-actions-top">
      <button :disabled="!patientStore.currentPatient.lastName" type="button" class="btn btn-info" @click="loadFromPatientStore">Load Current Patient from Store</button>
      <button type="button" class="btn btn-secondary" @click="loadFromProps">Load from Props</button>
      <button type="button" class="btn btn-secondary" @click="loadSampleData">Load Sample Data</button>
      <span v-if="patientStore.currentPatient.lastName" class="current-patient-info"> Current: {{ patientStore.currentPatient.firstName }} {{ patientStore.currentPatient.lastName }} </span>
      <span v-else class="no-patient-info"> No current patient selected </span>
    </div> -->

    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
      <div class="form-section full-width" :class="userStore.borderClass">
        <h3 style="text-align: left">Emergency Information</h3>

        <b-form-group label="Blood Type - Lab Result 1:" label-for="emergencyLabResult1" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="emergencyLabResult1" :class="modalTheme" v-model="form.emergencyLabResult1" size="sm" placeholder="Enter Lab Result 1" />
        </b-form-group>

        <b-form-group label="Blood Type - Lab Result 2:" label-for="emergencyLabResult2" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="emergencyLabResult2" :class="modalTheme" v-model="form.emergencyLabResult2" size="sm" placeholder="Enter Lab Result 2" />
        </b-form-group>

        <b-form-group label="Patient Reported:" label-for="emergencyPatientReported" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-select
            id="emergencyPatientReported"
            :class="modalTheme"
            v-model="form.emergencyPatientReported"
            size="sm"
            :options="[
              { value: 0, text: 'Select' },
              { value: 1, text: 'Yes' },
              { value: 2, text: 'No' },
              { value: 3, text: 'Unknown' },
            ]"
          />
        </b-form-group>

        <b-form-group label="Organ Donor:" label-for="emergencyOrganDonor" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-select
            id="emergencyOrganDonor"
            :class="modalTheme"
            v-model="form.emergencyOrganDonor"
            size="sm"
            :options="[
              { value: 0, text: 'Select' },
              { value: 1, text: 'Yes' },
              { value: 2, text: 'No' },
              { value: 3, text: 'Unknown' },
            ]"
          />
        </b-form-group>

        <b-form-group label="Is Deceased:" label-for="emergencyIsDeceased" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-checkbox id="emergencyIsDeceased" :class="modalTheme" v-model="form.emergencyIsDeceased" size="sm" switch />
        </b-form-group>

        <b-form-group label="Date of Death:" label-for="emergencyDateOfDeath" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-input id="emergencyDateOfDeath" :class="modalTheme" v-model="form.emergencyDateOfDeath" type="date" size="sm" />
        </b-form-group>

        <b-form-group label="Comments:" label-for="emergencyComments" label-cols="3" label-align="right" label-size="sm" label-class="form-label-align" class="mb-2">
          <b-form-textarea
            id="emergencyComments"
            :class="modalTheme"
            v-model="form.emergencyComments"
            size="sm"
            placeholder="Enter emergency comments (max 100 chars)"
            rows="3"
            max-rows="5"
            maxlength="100"
          />
        </b-form-group>
      </div>

      <pre style="color: cyan">{{ form }}</pre>

      <div class="form-actions">
        <b-button type="reset" variant="secondary">Reset</b-button>
        <b-button type="submit" variant="primary">Save Patient</b-button>
      </div>
    </b-form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import moment from "moment";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

// * STORE
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();

// Emits
const emit = defineEmits(["save-patient", "reset-form"]);

// & PROPS
const props = defineProps({
  testPatient: {
    Type: Object,
    Default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

// Create form factory function
function createForm() {
  return {
    emergencyLabResult1: "",
    emergencyLabResult2: "",
    emergencyPatientReported: 0,
    emergencyOrganDonor: 0,
    emergencyIsDeceased: false,
    emergencyDateOfDeath: "",
    emergencyComments: "",
    idTraining: false,
  };
}
//
// Form state
const form = ref(createForm());
const AreIdsShown = ref(true);

// Form validation
const isFormValid = () => {
  if (!form.value.firstName.trim()) {
    alert("First name is required");
    return false;
  }
  if (!form.value.lastName.trim()) {
    alert("Last name is required");
    return false;
  }
  if (!form.value.patientID.trim()) {
    alert("Patient ID is required");
    return false;
  }
  return true;
};

// Form handlers
function onSubmit() {
  if (!isFormValid()) {
    return;
  }

  const payload = {
    ...form.value,
    // Convert date strings to proper formats if needed
    chartReviewDate: form.value.chartReviewDate ? new Date(form.value.chartReviewDate).toISOString() : null,
    startDate: form.value.startDate ? new Date(form.value.startDate).toISOString() : null,
    endDate: form.value.endDate ? new Date(form.value.endDate).toISOString() : null,
    nextAppointment: form.value.nextAppointment ? new Date(form.value.nextAppointment).toISOString() : null,
    serviceDate: form.value.serviceDate ? moment(form.value.serviceDate).format("MM/DD/YYYY") : "",
  };

  emit("save-patient", payload);
  console.log("Saving patient:", payload);
}

function onReset() {
  form.value = createForm();
  emit("reset-form");
}

// Add method to handle emergency contact selection
function selectEmergencyContact() {
  // Add your selection logic here
  console.log("Select emergency contact Clicked        >>>>>>>>>  DO SOMETHING");
}
function editEmergencyContact() {
  // Add your selection logic here
  console.log("EDIT emergency contact clicked         >>>>>>>>>  DO SOMETHING");
}
// Load initial data (example with the provided values)
function loadSampleData() {
  form.value = {
    personID: 14526,
    firstName: "Sample",
    middleName: "M",
    lastName: "DATA",
    dateOfBirth: "1971-09-16",
    patientID: "2405061",
    memberID: "N/A",
    insuranceCarrier: "UNKNOWN",
    dob: "19710916",
    gender: "F",
    providerName: "Grizzle, Melissa",
    serviceDate: "2022-12-14",
    lastSeenByMe: "Grizzle, Melissa",
    chartReviewDate: moment("0001-01-01T00:00:00Z").isValid() ? moment("0001-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
    chartReviewBy: null,
    chartReviewNeeded: true,
    chartReviewComment: null,
    chartReviewRole: null,
    emrId: null,
    startDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    nextAppointmentWith: "",
    nextAppointmentReason: "",
    nextAppointmentType: "",
    nextAppointmentComment: "",
    patientStatus: true,
    endDate: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
    appointmentLocation: null,
    isScheduled: false,
    nextAppointment: moment("1900-01-01T00:00:00Z").format("YYYY-MM-DDTHH:mm"),
  };
}
function loadFromProps() {
  if (props.testPatient && typeof props.testPatient === "object") {
    form.value = {
      ...createForm(),
      ...props.testPatient,
      chartReviewDate: props.testPatient.chartReviewDate ? moment(props.testPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: props.testPatient.startDate ? moment(props.testPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: props.testPatient.endDate ? moment(props.testPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: props.testPatient.nextAppointment ? moment(props.testPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
  }
}

// New method to bind from store object to form
function loadFromPatientStore() {
  const currentPatient = patientStore.currentPatient;
  if (currentPatient && typeof currentPatient === "object") {
    form.value = {
      ...createForm(),
      ...currentPatient,
      // Handle date conversions
      dateOfBirth: currentPatient.dateOfBirth ? moment(currentPatient.dateOfBirth).format("YYYY-MM-DD") : "",
      serviceDate: currentPatient.serviceDate ? moment(currentPatient.serviceDate).format("YYYY-MM-DD") : "",
      chartReviewDate: currentPatient.chartReviewDate ? moment(currentPatient.chartReviewDate).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm"),
      startDate: currentPatient.startDate ? moment(currentPatient.startDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      endDate: currentPatient.endDate ? moment(currentPatient.endDate).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
      nextAppointment: currentPatient.nextAppointment ? moment(currentPatient.nextAppointment).format("YYYY-MM-DDTHH:mm") : moment("1900-01-01").format("YYYY-MM-DDTHH:mm"),
    };
    console.log("Loaded patient from store:", currentPatient);
  } else {
    console.warn("No current patient found in store");
    alert("No current patient available in store");
  }
}

onMounted(() => {
  // console.log("onMounted() : Patient Form >>>>");
  // console.log("props : testPatient ");
  // console.log(props.testPatient);
  // loadSampleData();
  // loadFromProps();
  // loadFromPatientStore();
});
</script>

<style scoped>
.patient-form-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  height: 65vh;
  overflow: hidden;
  overflow-y: auto;
}

.form-section {
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  text-align: center;
}

.form-section h3 {
  margin-bottom: 15px;
  font-size: 1.2em;
  border-bottom: 2px solid #007bff;
  padding-bottom: 5px;
  text-align: center;
}

.form-section.full-width {
  flex: 0 0 100%;
  width: 100%;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 20px 0;
  border-top: 1px solid #dee2e6;
  margin-top: 20px;
}

hr {
  border: none;
  height: 1px;
  background-color: #0d85fd;
  margin: 20px 0;
}

/* Bootstrap Vue form group label alignment */
.b-form-group .col-form-label {
  font-size: 15px !important;
  font-weight: 600;
  text-align: right !important;
  justify-content: flex-end !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  white-space: nowrap;
}

/* Remove Bootstrap Vue form group internal spacing */
.b-form-group {
  margin-bottom: 0.5rem !important;
}

.b-form-group .row {
  margin: 0 !important;
}

.b-form-group .row > [class*="col"] {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/* 10px gap between label and input columns */
.form-section .b-form-group .row > [class*="col"]:first-child {
  padding-right: 10px !important;
  padding-left: 0 !important;
}

.form-section .b-form-group .row > [class*="col"]:not(:first-child) {
  padding-left: 0 !important;
  padding-right: 5px !important;
}
</style>
